import styled from 'styled-components';

import { Button } from '../Button';

export const KebabIconButton = styled(Button)`
    padding: 0.125rem;
    border: none;

    & svg {
        height: 1.75rem;
    }
`;
